import React from "react";
import Button, { ButtonSizes, ButtonThemes } from "ui-components/button/button";
import "./assignDriver.scss";

export interface UnassignedRescheduleBarProps {
  selectedCount: number;
  onRescheduleClick: () => void;
}

export const UnassignedRescheduleBar: React.FC<UnassignedRescheduleBarProps> = ({
  selectedCount,
  onRescheduleClick,
}) => {
  return (
    <div className="assign-driver-bar assign-driver-bar--reschedule">
      <div className="assign-driver-bar__selected">{selectedCount} Selected</div>
      <div className="assign-driver-bar__form assign-driver-bar__form--message">
        Pickups are not scheduled for today. To proceed with assignment please reschedule them to
        today&apos;s date.
      </div>
      <div className="assign-driver-bar__action">
        <Button
          type="button"
          size={ButtonSizes.small}
          theme={ButtonThemes.blue}
          onClick={onRescheduleClick}
        >
          Reschedule
        </Button>
      </div>
    </div>
  );
};
